/**
 * @fileoverview Agent definition for character-modifier-v1.
 *
 * Takes a natural language change request from the author and applies
 * modifications to a single character's core attributes and planned
 * character arc. Results are shown for user confirmation before persisting
 * (Tier 2).
 *
 * @category entities.characters.modification
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'character-modifier-v1',
  kind: 'primitive',
  name: 'Character Modifier',
  description: 'Applies natural language change requests to a single character\'s core attributes and planned character arc. Returns proposed changes with commentary for user confirmation before persisting.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'entities.characters.modification',
    usedBy: [
      'primitives/use-character-modifier-v1.ts',
    ],
    relatedAgents: [
      'character-arc-creation-v2',
      'character-details-ideation-v2',
      'story-modifier-v1',
    ],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-sonnet-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
